import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { FuseNavigationService } from '@fuse/components/navigation/navigation.service';
import { EnumFuncoes } from 'app/shared/enum.service';
import { MatSnackBarConfigComponent } from 'app/shared/matSnackBarConfig/matSnackBarConfig.component';
import { PermissionModule } from './permission-modules.model';


@Injectable({
    providedIn: 'root'
})
export class PermissionModulesService {
    routeParams: any;
    matSnackBarConf: any;
    systemModules: PermissionModule[] = [

        {
            id: 1,
            descricao: 'Início',
            permiteEscrita: false,
            permiteLeitura: false,
            route: '/a2w/inicio',
            icon: 'home',
            navigationName: 'inicio',
            menuPai: 'inicio'
        },
        {
            id: 135,
            descricao: 'Funil de Vendas',
            permiteEscrita: false,
            permiteLeitura: false,
            route: '/mfe/multiple-funnels',
            icon: 'dashboard',
            navigationName: 'multiplos-funis',
            menuPai: 'funis'
        },
        {
            id: 8,
            descricao: 'Análise 360°',
            permiteEscrita: false,
            permiteLeitura: false,
            route: '#',
            icon: 'donut_large',
            navigationName: 'analise',
            menuPai: 'analise'
        },
        {
            id: 2,
            descricao: 'Agenda',
            permiteEscrita: false,
            permiteLeitura: false,
            route: '/a2w/gestor/agenda',
            icon: 'today',
            navigationName: 'agenda',
            menuPai: 'agenda'
        },
        //ATIVIDADES
        {
            id: 51,
            descricao: 'Resumo - Gráficos',
            permiteEscrita: false,
            permiteLeitura: false,
            route: '/a2w/gestor/paineis/atividades-graficos',
            icon: 'playlist_add_check',
            navigationName: 'atividades-graficos',
            menuPai: 'atividades'
        },
        {
            id: 4,
            descricao: 'Resumo - Cobertura e Positivação',
            permiteEscrita: false,
            permiteLeitura: false,
            route: '/a2w/gestor/paineis/cobertura-e-positivacao',
            icon: 'playlist_add_check',
            navigationName: 'cobertura-e-positivacao',
            menuPai: 'atividades'
        },
        {
            id: 120,
            descricao: 'Resumo - Mapas Estratégicos',
            permiteEscrita: false,
            permiteLeitura: false,
            route: '/a2w/gestor/atividades-mapas',
            icon: 'playlist_add_check',
            navigationName: 'atividades-mapas',
            menuPai: 'atividades'
        }, 
        {
            id: 17,
            descricao: 'Nova Atividade',
            permiteEscrita: false,
            permiteLeitura: false,
            route: '/a2w/gestor/atividades/new',
            icon: 'playlist_add_check',
            navigationName: 'novo-atividades',
            menuPai: 'atividades'
        },
        {
            id: 5,
            descricao: 'Exibir Atividades',
            permiteEscrita: false,
            permiteLeitura: false,
            route: '/a2w/gestor/atividades',
            icon: 'playlist_add_check',
            navigationName: 'todas-atividades',
            menuPai: 'atividades'
        },
        {
            id: 95,
            descricao: 'Automação - Executar em Massa',
            permiteEscrita: false,
            permiteLeitura: false,
            route: '/a2w/gestor/realizacao',
            icon: 'playlist_add_check',
            navigationName: 'realizacao-atividades',
            menuPai: 'atividades'
        },
        {
            id: 94,
            descricao: 'Automação - Criar Regras',
            permiteEscrita: false,
            permiteLeitura: false,
            route: '/a2w/gestor/definicoes',
            icon: 'playlist_add_check',
            navigationName: 'definicoes-atividades',
            menuPai: 'atividades'
        },
        {
            id: 6,
            descricao: 'Geração de Demandas',
            permiteEscrita: false,
            permiteLeitura: false,
            route: '/a2w/gestor/previsao-safras',
            icon: 'playlist_add_check',
            navigationName: 'previsao-safra',
            menuPai: 'atividades'
        },
        {
            id: 97,
            descricao: 'Relatórios - Fechamento de Produção',
            permiteEscrita: false,
            permiteLeitura: false,
            route: '/a2w/gestor/paineis/fechamento-producao',
            icon: 'playlist_add_check',
            navigationName: 'fechamento-prod',
            menuPai: 'atividades'
        },
        {
            id: 124,
            descricao: 'Relatórios - Formulários de Atividade',
            permiteEscrita: false,
            permiteLeitura: false,
            route: '/a2w/gestor/paineis/formularios-atividade',
            icon: 'playlist_add_check',
            navigationName: 'relatorio-formularios-atividade',
            menuPai: 'atividades'
        },
        {
            id: 106,
            descricao: 'Configurações - Motivos',
            permiteEscrita: false,
            permiteLeitura: false,
            route: '/a2w/supervisor/cadastros/motivo-atividade',
            icon: 'playlist_add_check',
            navigationName: 'motivo-atividade',
            menuPai: 'atividades'
        },
        {
            id: 126,
            descricao: 'Configurações - Texto Rodapé',
            permiteEscrita: false,
            permiteLeitura: false,
            route: '/a2w/supervisor/cadastros/rodape-atividade',
            icon: 'playlist_add_check',
            navigationName: 'rodape-atividade',
            menuPai: 'atividades'
        },
        {
            id: 33,
            descricao: 'Configurações - Objetivos',
            permiteEscrita: false,
            permiteLeitura: false,
            route: '/a2w/supervisor/cadastros/objetivo-atividade',
            icon: 'playlist_add_check',
            navigationName: 'objetivo-atividade',
            menuPai: 'atividades'
        },
        {
            id: 48,
            descricao: 'Configurações - Tipos',
            permiteEscrita: false,
            permiteLeitura: false,
            route: '/a2w/supervisor/cadastros/tipo-atividade',
            icon: 'playlist_add_check',
            navigationName: 'tipos-atividade',
            menuPai: 'atividades'
        },
        //NEGOCIAÇÕES
        {
            id: 25,
            descricao: 'Resumo - Faturamento',
            permiteEscrita: false,
            permiteLeitura: false,
            route: '/a2w/gestor/vendas/resumo/faturamento',
            icon: 'monetization_on',
            navigationName: 'painel-gestor',
            menuPai: 'negociacoes'
        },
        {
            id: 54,
            descricao: 'Resumo - Pedidos',
            permiteEscrita: false,
            permiteLeitura: false,
            route: '/a2w/gestor/paineis/pedidos-graficos',
            icon: 'monetization_on',
            navigationName: 'pedidos-graficos',
            menuPai: 'negociacoes'
        },
        {
            id: 91,
            descricao: 'Resumo - Pedidos por Funil',
            permiteEscrita: false,
            permiteLeitura: false,
            route: '/a2w/gestor/paineis/funil-vendas',
            icon: 'monetization_on',
            navigationName: 'funil-vendas',
            menuPai: 'negociacoes'
        },
        {
            id: 3,
            descricao: 'Resumo - Mapas Estratégicos',
            permiteEscrita: false,
            permiteLeitura: false,
            route: '/a2w/gestor/mapas',
            icon: 'monetization_on',
            navigationName: 'mapas-pedidos',
            menuPai: 'negociacoes'
        },
        {
            id: 132,
            descricao: 'Gestão de Entregas',
            permiteEscrita: false,
            permiteLeitura: false,
            route: '/mfe/plugins',
            icon: 'monetization_on',
            navigationName: 'gestao-entregas',
            menuPai: 'negociacoes'
        },
        {
            id: 12,
            descricao: 'Novo Pedido',
            permiteEscrita: false,
            permiteLeitura: false,
            route: '/a2w/gestor/vendas/pedidos/new',
            icon: 'monetization_on',
            navigationName: 'novo-pedidos',
            menuPai: 'negociacoes'
        },
        {
            id: 13,
            descricao: 'Exibir Pedidos',
            permiteEscrita: false,
            permiteLeitura: false,
            route: '/a2w/gestor/vendas/pedidos',
            icon: 'monetization_on',
            navigationName: 'todos-pedidos',
            menuPai: 'negociacoes'
        },

        {
            id: 70,
            descricao: 'Saldos e Preços',
            permiteEscrita: false,
            permiteLeitura: false,
            route: '/a2w/gestor/vendas/saldos-e-precos',
            icon: 'monetization_on',
            navigationName: 'saldos-e-precos',
            menuPai: 'negociacoes'
        },
        {
            id: 14,
            descricao: 'Exibir Notas Fiscais',
            permiteEscrita: false,
            permiteLeitura: false,
            route: '/a2w/gestor/vendas/notas-fiscais',
            icon: 'monetization_on',
            navigationName: 'notas-fiscais',
            menuPai: 'negociacoes'
        },
        {
            id: 103,
            descricao: 'Oferta Estruturada',
            permiteEscrita: false,
            permiteLeitura: false,
            route: '/a2w/gestor/vendas/ofertas',
            icon: 'monetization_on',
            navigationName: 'ofertas',
            menuPai: 'negociacoes'
        },
        {
            id: 100,
            descricao: 'Aprovações',
            permiteEscrita: false,
            permiteLeitura: false,
            route: '/a2w/gestor/vendas/aprovacoes-pedidos',
            icon: 'monetization_on',
            navigationName: 'aprovacoes',
            menuPai: 'negociacoes'
        },
        {
            id: 115,
            descricao: 'Estoque de Canal',
            permiteEscrita: false,
            permiteLeitura: false,
            route: '/a2w/gestor/vendas/estoque-canal',
            icon: 'monetization_on',
            navigationName: 'estoque-canal',
            menuPai: 'negociacoes'
        },
        {
            id: 123,
            descricao: 'Configurações - Campanhas',
            permiteEscrita: false,
            permiteLeitura: false,
            route: '/a2w/supervisor/cadastros/campanha',
            icon: 'monetization_on',
            navigationName: 'campanhas',
            menuPai: 'negociacoes'
        },
        {
            id: 128,
            descricao: 'Configurações - Casas Decimais',
            permiteEscrita: false,
            permiteLeitura: false,
            route: '/a2w/supervisor/cadastros/casas-decimais',
            icon: 'monetization_on',
            navigationName: 'casas-decimais',
            menuPai: 'negociacoes'
        },
        {
            id: 40,
            descricao: 'Configurações - Condições de Pagamentos',
            permiteEscrita: false,
            permiteLeitura: false,
            route: '/a2w/supervisor/cadastros/prazo-vencimento',
            icon: 'monetization_on',
            navigationName: 'prazos-vencimentos',
            menuPai: 'negociacoes'
        },
        {
            id: 30,
            descricao: 'Configurações - Formas de Pagamento',
            permiteEscrita: false,
            permiteLeitura: false,
            route: '/a2w/supervisor/cadastros/forma-pagto',
            icon: 'monetization_on',
            navigationName: 'formas-pagto',
            menuPai: 'negociacoes'
        },
        {
            id: 72,
            descricao: 'Configurações - Moedas e Cotações',
            permiteEscrita: false,
            permiteLeitura: false,
            route: '/a2w/supervisor/cadastros/moedas-cotacoes',
            icon: 'monetization_on',
            navigationName: 'moedas-cotacoes',
            menuPai: 'negociacoes'
        },
        {
            id: 133,
            descricao: 'Configurações - Motivos',
            permiteEscrita: false,
            permiteLeitura: false,
            route: '/mfe/reasons',
            icon: 'monetization_on',
            navigationName: 'motivos-reprogramacao',
            menuPai: 'negociacoes'
        },
        {
            id: 64,
            descricao: 'Configurações - Textos Rodapé',
            permiteEscrita: false,
            permiteLeitura: false,
            route: '/a2w/supervisor/cadastros/rodape-pedido',
            icon: 'monetization_on',
            navigationName: 'rodape-pedido',
            menuPai: 'negociacoes'
        },
        {
            id: 90,
            descricao: 'Configurações - Tipos de Atendimentos',
            permiteEscrita: false,
            permiteLeitura: false,
            route: '/a2w/supervisor/cadastros/tipo-atendimento',
            icon: 'monetization_on',
            navigationName: 'tipo-atendimento',
            menuPai: 'negociacoes'
        },
        {
            id: 49,
            descricao: 'Configurações - Tipos de Negociações',
            permiteEscrita: false,
            permiteLeitura: false,
            route: '/a2w/supervisor/cadastros/tipo-negociacao',
            icon: 'monetization_on',
            navigationName: 'tipos-negociacao',
            menuPai: 'negociacoes'
        },
        {
            id: 47,
            descricao: 'Configurações - Tipos de Fretes',
            permiteEscrita: false,
            permiteLeitura: false,
            route: '/a2w/supervisor/cadastros/tipo-frete-nota',
            icon: 'monetization_on',
            navigationName: 'tipo-frete-nota',
            menuPai: 'negociacoes'
        },
        {
            id: 71,
            descricao: 'Configurações - Tipos de Utilizações',
            permiteEscrita: false,
            permiteLeitura: false,
            route: '/a2w/supervisor/cadastros/tipo-utilizacao',
            icon: 'monetization_on',
            navigationName: 'tipo-utilizacao',
            menuPai: 'negociacoes'
        },
         {
            id: 134,
            descricao: 'Configurações - Transportadoras',
            permiteEscrita: false,
            permiteLeitura: false,
            route: '/mfe/carriers',
            icon: 'monetization_on',
            navigationName: 'transportadoras',
            menuPai: 'negociacoes'
        },
        {
            id: 101,
            descricao: 'Configurações - Regras de Aprovação',
            permiteEscrita: false,
            permiteLeitura: false,
            route: '/a2w/supervisor/cadastros/regras-de-aprovacao',
            icon: 'monetization_on',
            navigationName: 'regras-de-aprovacoes',
            menuPai: 'negociacoes'
        },
        { 
            id: 121,
            descricao: 'Configurações - Regras de Comissão',
            permiteEscrita: false,
            permiteLeitura: false,
            route: '/a2w/supervisor/cadastros/regras-de-comissao',
            icon: 'monetization_on',
            navigationName: 'regras-de-comissao',
            menuPai: 'negociacoes'
        },
        {
            id: 75,
            descricao: 'Configurações - Frete Flex',
            permiteEscrita: false,
            permiteLeitura: false,
            route: '/a2w/supervisor/cadastros/tabela-fretes',
            icon: 'monetization_on',
            navigationName: 'tabela-fretes',
            menuPai: 'negociacoes'
        },
        {
            id: 98,
            descricao: 'Configurações - Manejos para Oferta',
            permiteEscrita: false,
            permiteLeitura: false,
            route: '/a2w/supervisor/cadastros/manejo',
            icon: 'monetization_on',
            navigationName: 'manejos',
            menuPai: 'negociacoes'
        },
        {
            id: 93,
            descricao: 'Configurações - Semáforos',
            permiteEscrita: false,
            permiteLeitura: false,
            route: '/a2w/supervisor/cadastros/semaforo',
            icon: 'monetization_on',
            navigationName: 'semaforo',
            menuPai: 'negociacoes'
        },
        //PLANEJAMENTO

        {
            id: 53,
            descricao: 'Resumo - Metas',
            permiteEscrita: false,
            permiteLeitura: false,
            route: '/a2w/gestor/paineis/graficos-metas',
            icon: 'assessment',
            navigationName: 'graficos-metas',
            menuPai: 'planejamento'
        },
        {
            id: 24,
            descricao: 'Resumo - Relatório de Metas',
            permiteEscrita: false,
            permiteLeitura: false,
            route: '/a2w/gestor/relatorios',
            icon: 'assessment',
            navigationName: 'relatorios-personalizados-consultas',
            menuPai: 'planejamento'
        },
        {
            id: 9,
            descricao: 'Definições de Metas',
            permiteEscrita: false,
            permiteLeitura: false,
            route: '/a2w/gestor/definicoes-comerciais/metas',
            icon: 'assessment',
            navigationName: 'metas',
            menuPai: 'planejamento'
        },
        {
            id: 34,
            descricao: 'Pacotes Tecnológicos',
            permiteEscrita: false,
            permiteLeitura: false,
            route: '/a2w/gestor/pacotes-tecnologicos',
            icon: 'assessment',
            navigationName: 'pacotes-tecnologicos',
            menuPai: 'planejamento'
        },
        {
            id: 108,
            descricao: 'Variáveis de Configuração',
            permiteEscrita: false,
            permiteLeitura: false,
            route: '/a2w/supervisor/cadastros/variaveis-genericas',
            icon: 'assessment',
            navigationName: 'variaveis-genericas',
            menuPai: 'planejamento'
        },
        //PARCEIROS 
        {
            id: 74,
            descricao: 'Novo Cliente',
            permiteEscrita: false,
            permiteLeitura: false,
            route: '/a2w/supervisor/cadastros/parceiros-negocios/clientes-leads/new',
            icon: 'groups',
            navigationName: 'novo-cliente',
            menuPai: 'parceiros'
        },
        {
            id: 76,
            descricao: 'Exibir Clientes',
            permiteEscrita: false,
            permiteLeitura: false,
            route: '/a2w/supervisor/cadastros/parceiros-negocios/clientes-leads',
            icon: 'groups',
            navigationName: 'todos-clientes',
            menuPai: 'parceiros'
        },
        {
            id: 122,
            descricao: 'Resumo - Visão de Clientes',
            permiteEscrita: false,
            permiteLeitura: false,
            route: '/a2w/gestor/paineis/visao-clientes',
            icon: 'groups',
            navigationName: 'visao-clientes',
            menuPai: 'parceiros'
        },
        {
            id: 37,
            descricao: 'Consultores/ Colaboradores',
            permiteEscrita: false,
            permiteLeitura: false,
            route: '/a2w/supervisor/cadastros/parceiros-negocios/vendedor',
            icon: 'groups',
            navigationName: 'vendedores',
            menuPai: 'parceiros'
        },
        {
            id: 83,
            descricao: 'Configurações - Características',
            permiteEscrita: false,
            permiteLeitura: false,
            route: '/a2w/supervisor/cadastros/parceiros-negocios/caracteristica',
            icon: 'groups',
            navigationName: 'caracteristica',
            menuPai: 'parceiros'
        },
        {
            id: 84,
            descricao: 'Configurações - Classificações',
            permiteEscrita: false,
            permiteLeitura: false,
            route: '/a2w/supervisor/cadastros/parceiros-negocios/classificacao',
            icon: 'groups',
            navigationName: 'classificacao',
            menuPai: 'parceiros'
        },
        {
            id: 81,
            descricao: 'Configurações - Financeiro',
            permiteEscrita: false,
            permiteLeitura: false,
            route: '/a2w/supervisor/cadastros/parceiros-negocios/financeiro',
            icon: 'groups',
            navigationName: 'financeiro-perfil',
            menuPai: 'parceiros'
        },
        {
            id: 85,
            descricao: 'Configurações - Hobbies',
            permiteEscrita: false,
            permiteLeitura: false,
            route: '/a2w/supervisor/cadastros/parceiros-negocios/hobbie',
            icon: 'groups',
            navigationName: 'hobbie',
            menuPai: 'parceiros'
        },
        {
            id: 80,
            descricao: 'Configurações - Origem',
            permiteEscrita: false,
            permiteLeitura: false,
            route: '/a2w/supervisor/cadastros/parceiros-negocios/origem',
            icon: 'groups',
            navigationName: 'origem',
            menuPai: 'parceiros'
        },
        {
            id: 82,
            descricao: 'Configurações - Regiões',
            permiteEscrita: false,
            permiteLeitura: false,
            route: '/a2w/supervisor/cadastros/parceiros-negocios/regiao',
            icon: 'groups',
            navigationName: 'regiao',
            menuPai: 'parceiros'
        },
        {
            id: 86,
            descricao: 'Configurações - Segmentos',
            permiteEscrita: false,
            permiteLeitura: false,
            route: '/a2w/supervisor/cadastros/parceiros-negocios/segmento',
            icon: 'groups',
            navigationName: 'segmento',
            menuPai: 'parceiros'
        },
        {
            id: 79,
            descricao: 'Configurações - Status',
            permiteEscrita: false,
            permiteLeitura: false,
            route: '/a2w/supervisor/cadastros/parceiros-negocios/status',
            icon: 'groups',
            navigationName: 'status',
            menuPai: 'parceiros'
        },
        {
            id: 105,
            descricao: 'Configurações - Tipos de Endereços',
            permiteEscrita: false,
            permiteLeitura: false,
            route: '/a2w/supervisor/cadastros/parceiros-negocios/tipos-enderecos',
            icon: 'groups',
            navigationName: 'tipos-enderecos',
            menuPai: 'parceiros'
        },
        {
            id: 127,
            descricao: 'Configurações - Grupo de Consultores',
            permiteEscrita: false,
            permiteLeitura: false,
            route: '/a2w/supervisor/cadastros/parceiros-negocios/grupo-consultores',
            icon: 'groups',
            navigationName: 'grupo-consultores',
            menuPai: 'parceiros'
        },
        //PRODUTOS  
        {
            id: 45,
            descricao: 'Novo Produto',
            permiteEscrita: false,
            permiteLeitura: false,
            route: '/a2w/supervisor/cadastros/produto/new',
            icon: 'add_shopping_cart',
            navigationName: 'novo-produtos',
            menuPai: 'produtos'
        },
        {
            id: 41,
            descricao: 'Exibir Produtos',
            permiteEscrita: false,
            permiteLeitura: false,
            route: '/a2w/supervisor/cadastros/produto',
            icon: 'add_shopping_cart',
            navigationName: 'todos-produtos',
            menuPai: 'produtos'
        },
        {
            id: 28,
            descricao: 'Configurações - Embalagens',
            permiteEscrita: false,
            permiteLeitura: false,
            route: '/a2w/supervisor/cadastros/embalagens',
            icon: 'add_shopping_cart',
            navigationName: 'embalagens',
            menuPai: 'produtos'
        },
        {
            id: 31,
            descricao: 'Configurações - Grupos de Produtos',
            permiteEscrita: false,
            permiteLeitura: false,
            route: '/a2w/supervisor/cadastros/grupo-produto',
            icon: 'add_shopping_cart',
            navigationName: 'grupo-produtos',
            menuPai: 'produtos'
        },
        {
            id: 32,
            descricao: 'Configurações - Listas de Preços',
            permiteEscrita: false,
            permiteLeitura: false,
            route: '/a2w/supervisor/cadastros/lista-precos-custos/preco',
            icon: 'add_shopping_cart',
            navigationName: 'listas-precos',
            menuPai: 'produtos'
        },
        {
            id: 119,
            descricao: 'Configurações - Listas de Custos',
            permiteEscrita: false,
            permiteLeitura: false,
            route: '/a2w/supervisor/cadastros/lista-precos-custos/custo',
            icon: 'add_shopping_cart',
            navigationName: 'lista-precos-custos',
            menuPai: 'produtos'
        },
        {
            id: 89,
            descricao: 'Configurações - Marcas',
            permiteEscrita: false,
            permiteLeitura: false,
            route: '/a2w/supervisor/cadastros/marca',
            icon: 'add_shopping_cart',
            navigationName: 'marca',
            menuPai: 'produtos'
        },
        {
            id: 11,
            descricao: 'Configurações - Produtos Substitutos',
            permiteEscrita: false,
            permiteLeitura: false,
            route: '/a2w/supervisor/cadastros/produtos-substitutos',
            icon: 'add_shopping_cart',
            navigationName: 'produtos-substitutos',
            menuPai: 'produtos'
        },
        {
            id: 50,
            descricao: 'Configurações - Unidades de Medida',
            permiteEscrita: false,
            permiteLeitura: false,
            route: '/a2w/supervisor/cadastros/unidade',
            icon: 'add_shopping_cart',
            navigationName: 'unidades-medidas',
            menuPai: 'produtos'
        },
        //FINANCEIRO
        {
            id: 15,
            descricao: 'Resumo - Gráfico',
            permiteEscrita: false,
            permiteLeitura: false,
            route: '#',
            icon: 'attach_money',
            navigationName: 'graficos-financeiro',
            menuPai: 'financeiro'
        },
        {
            id: 16,
            descricao: 'Limite de Crédito',
            permiteEscrita: false,
            permiteLeitura: false,
            route: '/a2w/gestor/financeiro/limite-credito',
            icon: 'attach_money',
            navigationName: 'limite-credito',
            menuPai: 'financeiro'
        },
        {
            id: 18,
            descricao: 'Títulos a Receber',
            permiteEscrita: false,
            permiteLeitura: false,
            route: '/a2w/gestor/financeiro/recebimentos',
            icon: 'attach_money',
            navigationName: 'recebimentos',
            menuPai: 'financeiro'
        },
        //DESPESAS
        {
            id: 52,
            descricao: 'Resumo - Gráficos',
            permiteEscrita: false,
            permiteLeitura: false,
            route: '/a2w/gestor/paineis/relatorio-despesas',
            icon: 'work_outline',
            navigationName: 'graficos-despesas',
            menuPai: 'despesas'
        },
        {
            id: 10,
            descricao: 'Adiantamentos',
            permiteEscrita: false,
            permiteLeitura: false,
            route: '/a2w/gestor/aprovacoes',
            icon: 'work_outline',
            navigationName: 'aprovacaoes-despesas',
            menuPai: 'despesas'
        },
        {
            id: 96,
            descricao: 'Níveis de Aprovação',
            permiteEscrita: false,
            permiteLeitura: false,
            route: '/a2w/gestor/niveis-aprovacoes',
            icon: 'work_outline',
            navigationName: 'niveis-aprovacoes',
            menuPai: 'despesas'
        },
        {
            id: 65,
            descricao: 'Extratos',
            permiteEscrita: false,
            permiteLeitura: false,
            route: '/a2w/gestor/despesas/saldos-extratos',
            icon: 'work_outline',
            navigationName: 'despesas-extratos',
            menuPai: 'despesas'
        },
        {
            id: 7,
            descricao: 'Exibir Relatórios',
            permiteEscrita: false,
            permiteLeitura: false,
            route: '/a2w/gestor/relatorio-despesas-viagens',
            icon: 'work_outline',
            navigationName: 'relatorio-despesa-viagem',
            menuPai: 'despesas'
        },
        {
            id: 110,
            descricao: 'A2W Card - Cartões por usuário',
            permiteEscrita: false,
            permiteLeitura: false,
            route: '/a2w/gestor/a2w-card/cartoes-por-usuario',
            icon: 'work_outline',
            navigationName: 'cartoes-usuario',
            menuPai: 'despesas'
        },
        {
            id: 116,
            descricao: 'A2W Card - Gestão de Cartões',
            permiteEscrita: false,
            permiteLeitura: false,
            route: '/a2w/gestor/a2w-manager-card/gestao-cartoes',
            icon: 'work_outline',
            navigationName: 'gestao-cartoes',
            menuPai: 'despesas'
        },
        {
            id: 104,
            descricao: 'A2W Card - Rendimento Pay',
            permiteEscrita: false,
            permiteLeitura: false,
            route: '&&',
            icon: 'work_outline',
            navigationName: 'rendimento-pay',
            menuPai: 'despesas'
        },
        {
            id: 107,
            descricao: 'Configurações - Projetos',
            permiteEscrita: false,
            permiteLeitura: false,
            route: '/a2w/supervisor/cadastros/relatorio-despesas/projetos',
            icon: 'work_outline',
            navigationName: 'projetos',
            menuPai: 'despesas'
        },
        {
            id: 44,
            descricao: 'Configurações - Regras e Limites',
            permiteEscrita: false,
            permiteLeitura: false,
            route: '/a2w/supervisor/cadastros/relatorio-despesas/regras-limite-despesas-viagens',
            icon: 'work_outline',
            navigationName: 'regras-limite-despesas-viagens',
            menuPai: 'despesas'
        },
        {
            id: 42,
            descricao: 'Configurações - Tipos de Despesas',
            permiteEscrita: false,
            permiteLeitura: false,
            route: '/a2w/supervisor/cadastros/relatorio-despesas/tipos-despesas',
            icon: 'work_outline',
            navigationName: 'tipos-despesas',
            menuPai: 'despesas'
        },
        {
            id: 78,
            descricao: 'Configurações - Tipos de Lançamentos',
            permiteEscrita: false,
            permiteLeitura: false,
            route: '/a2w/supervisor/cadastros/relatorio-despesas/tipos-lancamentos',
            icon: 'work_outline',
            navigationName: 'tipos-lancamentos',
            menuPai: 'despesas'
        },
        {
            id: 43,
            descricao: 'Configurações - Tipos de Pagamentos',
            permiteEscrita: false,
            permiteLeitura: false,
            route: '/a2w/supervisor/cadastros/relatorio-despesas/tipos-pagamentos',
            icon: 'work_outline',
            navigationName: 'tipos-pagamentos',
            menuPai: 'despesas'
        },
        {
            id: 77,
            descricao: 'Configurações - Veiculos',
            permiteEscrita: false,
            permiteLeitura: false,
            route: '#'/* '/a2w/supervisor/cadastros/relatorio-despesas/veiculos' */,
            icon: 'work_outline',
            navigationName: 'veiculos',
            menuPai: 'despesas'
        },
        //PERMISSOES
        {
            id: 68,
            descricao: 'Resumo - Acessos',
            permiteEscrita: false,
            permiteLeitura: false,
            route: '/a2w/supervisor/restricoes-permissoes/acessos',
            icon: 'lock',
            navigationName: 'acesso',
            menuPai: 'permissoes'
        },
        {
            id: 36,
            descricao: 'Novo Usuário',
            permiteEscrita: false,
            permiteLeitura: false,
            route: '/a2w/supervisor/restricoes-permissoes/usuario/new',
            icon: 'lock',
            navigationName: 'novo-usuario',
            menuPai: 'permissoes'
        },
        {
            id: 59,
            descricao: 'Exibir Usuários',
            permiteEscrita: false,
            permiteLeitura: false,
            route: '/a2w/supervisor/restricoes-permissoes/usuario',
            icon: 'lock',
            navigationName: 'usuario',
            menuPai: 'permissoes'
        },
        {
            id: 58,
            descricao: 'Grupos de Usuários',
            permiteEscrita: false,
            permiteLeitura: false,
            route: '/a2w/supervisor/restricoes-permissoes/grupo-usuarios',
            icon: 'lock',
            navigationName: 'grupo-usuario',
            menuPai: 'permissoes'
        },
        //PARAMETROS
        {
            id: 112,
            descricao: 'Alertas - Notificações do Sistema',
            permiteEscrita: false,
            permiteLeitura: false,
            route: '/a2w/supervisor/configuracoes/flags-notificacoes',
            icon: 'toggle_off',
            navigationName: 'flags-notificacoes',
            menuPai: 'parametros'
        },
        {
            id: 99,
            descricao: 'Meus Apps - App Armazenagem',
            permiteEscrita: false,
            permiteLeitura: false,
            route: '/a2w/supervisor/configuracoes/personalizacao-apps/armazenagem',
            icon: 'toggle_off',
            navigationName: 'app-armazenagem',
            menuPai: 'parametros'
        },
        {
            id: 87,
            descricao: 'Meus Apps - App Consultor - Cards',
            permiteEscrita: false,
            permiteLeitura: false,
            route: '/a2w/supervisor/cadastros/definicao',
            icon: 'toggle_off',
            navigationName: 'definicao',
            menuPai: 'parametros'
        },
        {
            id: 109,
            descricao: 'Meus Apps - App Distribuidor',
            permiteEscrita: false,
            permiteLeitura: false,
            route: '/a2w/supervisor/configuracoes/personalizacao-apps/distribuidor',
            icon: 'toggle_off',
            navigationName: 'app-distribuidor',
            menuPai: 'parametros'
        },
        {
            id: 29,
            descricao: 'Empresas',
            permiteEscrita: false,
            permiteLeitura: false,
            route: '/a2w/supervisor/cadastros/empresa',
            icon: 'toggle_off',
            navigationName: 'empresas',
            menuPai: 'parametros'
        },
        {
            id: 63,
            descricao: 'Grupos de Empresas',
            permiteEscrita: false,
            permiteLeitura: false,
            route: '/a2w/supervisor/cadastros/grupo-empresa',
            icon: 'toggle_off',
            navigationName: 'grupo-empresas',
            menuPai: 'parametros'
        },
        {
            id: 27,
            descricao: 'Culturas',
            permiteEscrita: false,
            permiteLeitura: false,
            route: '/a2w/supervisor/cadastros/culturas',
            icon: 'toggle_off',
            navigationName: 'culturas',
            menuPai: 'parametros'
        },
        {
            id: 62,
            descricao: 'Grupos de Culturas',
            permiteEscrita: false,
            permiteLeitura: false,
            route: '/a2w/supervisor/cadastros/grupo-cultura',
            icon: 'toggle_off',
            navigationName: 'grupo-culturas',
            menuPai: 'parametros'
        },
        {
            id: 46,
            descricao: 'Safras',
            permiteEscrita: false,
            permiteLeitura: false,
            route: '/a2w/supervisor/cadastros/safra',
            icon: 'toggle_off',
            navigationName: 'safra',
            menuPai: 'parametros'
        },
        {
            id: 26,
            descricao: 'Integrações - Sincronizar com o ERP',
            permiteEscrita: false,
            permiteLeitura: false,
            route: '/a2w/supervisor/configuracoes/integracoes',
            icon: 'toggle_off',
            navigationName: 'integracoes',
            menuPai: 'parametros'
        },
        {
            id: 92,
            descricao: 'Integrações - Importação por Planilhas',
            permiteEscrita: false,
            permiteLeitura: false,
            route: '/a2w/supervisor/configuracoes/upload-de-planilhas',
            icon: 'toggle_off',
            navigationName: 'upload-de-planilhas',
            menuPai: 'parametros'
        },
        {
            id: 73,
            descricao: 'Integrações - API Google Maps',
            permiteEscrita: false,
            permiteLeitura: false,
            route: '/a2w/supervisor/configuracoes/cadastro-key',
            icon: 'toggle_off',
            navigationName: 'cadastro-key',
            menuPai: 'parametros'
        },
        {
            id: 117,
            descricao: 'Integrações - Autenticação EntraID',
            permiteEscrita: false,
            permiteLeitura: false,
            route: '/a2w/supervisor/configuracoes/autenticacao-entraid',
            icon: 'toggle_off',
            navigationName: 'config-entraid',
            menuPai: 'parametros'
        },
        {
            id: 118,
            descricao: 'Integrações - ZapSign',
            permiteEscrita: false,
            permiteLeitura: false,
            route: '/a2w/supervisor/configuracoes/zap-sign',
            icon: 'toggle_off',
            navigationName: 'zap-sign',
            menuPai: 'parametros'
        },
        {
            id: 69,
            descricao: 'Regras de Negócios',
            permiteEscrita: false,
            permiteLeitura: false,
            route: '/a2w/supervisor/configuracoes/regras-negocios',
            icon: 'toggle_off',
            navigationName: 'regras-negocios',
            menuPai: 'parametros'
        },
        //CENTRAL
        {
            id: 56,
            descricao: 'Precisa de Ajuda?',
            permiteEscrita: false,
            permiteLeitura: false,
            route: '&&',
            icon: 'headset_mic',
            navigationName: 'atendimento',
            menuPai: 'central'
        },
        {
            id: 39,
            descricao: 'Termos e Condições - Ativação da Conta',
            permiteEscrita: false,
            permiteLeitura: false,
            route: '/a2w/assinaturas/termos-privacidade',
            icon: 'headset_mic',
            navigationName: 'documento',
            menuPai: 'central'
        },
        {
            id: 38,
            descricao: 'Termos e Condições - Assinaturas',
            permiteEscrita: false,
            permiteLeitura: false,
            route: '/a2w/assinaturas/logs',
            icon: 'headset_mic',
            navigationName: 'log',
            menuPai: 'central'
        },
        {
            id: 60,
            descricao: 'Termos e Condições - Política de Privacidade',
            permiteEscrita: false,
            permiteLeitura: false,
            route: '&&',
            icon: 'headset_mic',
            navigationName: 'politica',
            menuPai: 'central'
        },
        {
            id: 61,
            descricao: 'Termos e Condições - Termos de Uso',
            permiteEscrita: false,
            permiteLeitura: false,
            route: '&&',
            icon: 'headset_mic',
            navigationName: 'termos-uso',
            menuPai: 'central'
        },
        //NÃO SÃO MOSTRADOS NO FRONT
        {
            id: 67,
            descricao: 'Meu Perfil',
            permiteEscrita: false,
            permiteLeitura: false,
            route: '/a2w/perfil-user',
            icon: '#',
            navigationName: 'meu-perfil',
            menuPai: ''
        },
        {
            id: 113,
            descricao: 'Notificações',
            permiteEscrita: false,
            permiteLeitura: false,
            route: '/a2w/notifications',
            icon: '#',
            navigationName: 'notifications',
            menuPai: ''
        },
        { 
            id: 35,
            descricao: 'Clientes',
            permiteEscrita: false,
            permiteLeitura: false,
            route: '/a2w/supervisor/cadastros/parceiros-negocios/cliente',
            icon: 'groups',
            navigationName: 'clientes',
            menuPai: ''
        },
        {
            id: 114,
            descricao: 'Módulos',
            permiteEscrita: false,
            permiteLeitura: false,
            route: '/a2w/supervisor/restricoes-permissoes/modulos',
            icon: 'lock',
            navigationName: 'modulo',
            menuPai: ''
        },
        { 
            id: 130,
            descricao: 'Lara IA',
            permiteEscrita: false,
            permiteLeitura: false,
            route: '/a2w/lara/lara-menu',
            icon: '#',
            navigationName: 'lara',
            menuPai: ''
        },
        {
            id: 131,
            descricao: 'Notifica',
            permiteEscrita: false,
            permiteLeitura: false,
            route: '/a2w/lara/notifica',
            icon: '#',
            navigationName: 'notifica',
            menuPai: ''
        },

        /**************************************************************************************************************************************/
        /**************************************************************************************************************************************/
        /******************* ATENCAO - ULTIMO ID UTILIZADO 132 - FAVOR ATUALIZAR ESSA LINHA APOS CRIAR UM NOVO MENU*****/
        /***********  ATUALIZAR NAVIGATION navigation.ts E PERMISSION MODULE permission-modules.service.ts **********/
        /**************************************************************************************************************************************/
        /**************************************************************************************************************************************/

    ];


    modulesMenuPai: ModulePai [] = [
        {
            id: 'inicio',
            title: 'Início',
            icon: 'home',
            menuPai: 'inicio',
        },
        {
            id: 'pipeline',
            title: 'Funil de Vendas',
            icon: 'dashboard',
            menuPai: 'pipeline',
        },
        {
            id: 'funis',
            title: 'Múltiplos Funis',
            icon: 'monetization_on',
            menuPai: 'funis',
        },
        {
            id: 'analise',
            title: 'Análise 360°',
            icon: 'donut_large',
            menuPai: 'analise',
        },
        {
            id: 'agenda',
            title: 'Agenda',
            icon: 'today',
            menuPai: 'agenda',
        },
        {
            id: 'atividades-pai',
            title: 'Atividades',
            icon: 'playlist_add_check',
            menuPai: 'atividades',
        },
        {
            id: 'negociacoes-pai',
            title: 'Negociações',
            icon: 'monetization_on',
            menuPai: 'negociacoes',
        },
        {
            id: 'planejamento-pai',
            title: 'Planejamento Comercial',
            icon: 'assessment',
            menuPai: 'planejamento',
        },
        {
            id: 'parceiros-pai',
            title: 'Parceiros de Negócios',
            icon: 'groups',
            menuPai: 'parceiros',
        },
        {
            id: 'produtos-pai',
            title: 'Produtos',
            icon: 'add_shopping_cart',
            menuPai: 'produtos',
        },
        {
            id: 'financeiro-pai',
            title: 'Financeiro',
            icon: 'attach_money',
            menuPai: 'financeiro',
        },
        {
            id: 'despesas-pai',
            title: 'Despesas de Viagens',
            icon: 'work_outline',
            menuPai: 'despesas',
        },
        {
            id: 'permissoes-pai',
            title: 'Restrições e Permissões',
            icon: 'lock',
            menuPai: 'permissoes',
        },
        {
            id: 'parametro-pai',
            title: 'Parâmetros do Ambiente',
            icon: 'toggle_off',
            menuPai: 'parametros',
        }, 
        {
            id: 'central-pai',
            title: 'Central do Cliente',
            icon: 'headset_mic',
            menuPai: 'central',
        }
    ];

    funcaoRules = {
        [EnumFuncoes.Administrador]: {
            allowed: () => true
        },
        [EnumFuncoes.Gestor]: {
            allowed: () => true
        },
        [EnumFuncoes.TI]: {
            allowed: () => true
        },
        [EnumFuncoes.GestorRDV]: {
            allowed: (item) => 
                item.menuPai === 'inicio' ||
                item.menuPai === 'funis' ||
                (item.menuPai === 'parceiros' && !([122].includes(item.id) || [122].includes(item.companySystemModuleItemId))) ||
                item.menuPai === 'despesas' ||
                item.menuPai === 'permissoes' ||
                (item.menuPai === 'parametros' && ([112, 29, 63, 26, 92, 117, 69].includes(item.id) || [112, 29, 63, 26, 92, 117, 69].includes(item.companySystemModuleItemId))) ||
                item.menuPai === 'central'
        },
        [EnumFuncoes.DistribuidorLojista]: {
            allowed: (item) =>
                item.menuPai === 'inicio' ||
                item.menuPai === 'funis' ||
                (item.menuPai === 'negociacoes' && ([25, 54, 12, 13, 70, 14, 115].includes(item.id) || [25, 54, 12, 13, 70, 14, 115].includes(item.companySystemModuleItemId))) ||
                (item.menuPai === 'financeiro' && ([18].includes(item.id) || [18].includes(item.companySystemModuleItemId))) ||
                item.menuPai === 'central'
        },
        [EnumFuncoes.VendedorCampo]: {
            allowed: (item) =>
                item.menuPai === 'inicio' ||
                item.menuPai === 'funis' ||
                item.menuPai === 'agenda' ||
                (item.menuPai === 'atividades' && ([51, 4, 120, 17, 5, 6, 97, 124].includes(item.id) || [51, 4, 120, 17, 5, 6, 97, 124].includes(item.companySystemModuleItemId))) ||
                (item.menuPai === 'negociacoes' && ([25, 54, 91, 3, 12, 13, 70, 14, 115, 103].includes(item.id) || [25, 54, 91, 3, 12, 13, 70, 14, 115, 103].includes(item.companySystemModuleItemId))) ||
                (item.menuPai === 'planejamento' && ([53, 24].includes(item.id) || [53, 24].includes(item.companySystemModuleItemId))) ||
                (item.menuPai === 'parceiros' && ([122, 74, 76].includes(item.id) || [122, 74, 76].includes(item.companySystemModuleItemId))) ||
                (item.menuPai === 'produtos' && ([41, 119].includes(item.id) || [41, 119].includes(item.companySystemModuleItemId))) ||
                item.menuPai === 'financeiro' ||
                (item.menuPai === 'despesas' && ([52].includes(item.id) || [52].includes(item.companySystemModuleItemId))) ||
                item.menuPai === 'central'
        },
        [EnumFuncoes.VendedorBalcão]: {
            allowed: (item) =>
                item.menuPai === 'inicio' ||
                item.menuPai === 'funis' ||
                item.menuPai === 'agenda' ||
                (item.menuPai === 'atividades' && ([51, 4, 120, 17, 5, 6, 97, 124].includes(item.id) || [51, 4, 120, 17, 5, 6, 97, 124].includes(item.companySystemModuleItemId))) ||
                (item.menuPai === 'negociacoes' && ([25, 54, 91, 3, 12, 13, 70, 14, 115, 103].includes(item.id) || [25, 54, 91, 3, 12, 13, 70, 14, 115, 103].includes(item.companySystemModuleItemId))) ||
                (item.menuPai === 'planejamento' && ([53, 24].includes(item.id) || [53, 24].includes(item.companySystemModuleItemId))) ||
                (item.menuPai === 'parceiros' && ([122, 74, 76].includes(item.id) || [122, 74, 76].includes(item.companySystemModuleItemId))) ||
                (item.menuPai === 'produtos' && ([41, 119].includes(item.id) || [41, 119].includes(item.companySystemModuleItemId))) ||
                item.menuPai === 'financeiro' ||
                (item.menuPai === 'despesas' && ([52].includes(item.id) || [52].includes(item.companySystemModuleItemId))) ||
                item.menuPai === 'central'
        }
    };


    constructor(
        private _fuseNavigationService: FuseNavigationService,
        private _matSnackBar: MatSnackBar
    ) {
        this.matSnackBarConf = new MatSnackBarConfigComponent();
    }

    getModulesPai(): ModulePai[] {
        return this.modulesMenuPai;
    }

    getModules(): PermissionModule[] {
        return this.systemModules;
    }

    getModuleById(id: number): PermissionModule {
        return this.systemModules.find(x => x.id == id);
    }

    getModulesPermitidos(): PermissionModule[] {
        return this.systemModules.filter(x => x.permiteEscrita == true || x.permiteLeitura == true);
    }

    setPermissionAll(id: number, permitir: boolean) {
        this.systemModules.find(x => x.id == id).permiteEscrita = permitir;
        this.systemModules.find(x => x.id == id).permiteLeitura = permitir;
    }

    setPermissionEscrita(id: number, permitir: boolean) {
        try {
            if (this.systemModules.filter(x => x.id == id).length > 0) {
                this.systemModules.find(x => x.id == id).permiteEscrita = permitir;
            }
        } catch {

        }
    }

    isPermited(navigationName: string): boolean {

        if (this.systemModules.filter(x => x.navigationName == navigationName).length > 0) {
            if (this.systemModules.find(x => x.navigationName == navigationName).permiteEscrita) {
                return true;
            }
            else {
                this._matSnackBar.open('Não possui permissão para esta ação.', 'OK', this.matSnackBarConf.returnMatSnackBarConfig('warning'));
                return false;
            }
        }
        else {
            this._matSnackBar.open('Módulo não cadastrado. Não possui permissão para esta ação.', 'OK', this.matSnackBarConf.returnMatSnackBarConfig('warning'));
            return false;
        }
    }

    setPermissionLeitura(id: number, permitir: boolean) {
        try {
            if (this.systemModules.filter(x => x.id == id).length > 0) {
                this.systemModules.find(x => x.id == id).permiteLeitura = permitir;
            }
        } catch {

        }
    }

    ajustaChildrens(filho): boolean {
        if (filho.children != null && filho.children != undefined) {
            let cont = 0;
            for (const item of filho.children) {
                if (item.children != null && item.children != undefined) {
                    if (this.ajustaChildrens(item)) {
                        cont = cont + 1;
                    }
                }
                else {
                    if (item.hidden == true) {
                        cont = cont + 1;
                    }
                }
            }

            if (cont == filho.children.length) {
                this._fuseNavigationService.updateNavigationItem(filho.id, {
                    hidden: true
                });
                return true;
            }
            else {
                this._fuseNavigationService.updateNavigationItem(filho.id, {
                    hidden: false
                });
                return false;
            }
        }

    }

    updateNavigation() {
        this.systemModules.forEach((module) => {

            this._fuseNavigationService.updateNavigationItem(module.navigationName, {
                hidden: false
            });

            if (!module.permiteEscrita && !module.permiteLeitura) {
                this._fuseNavigationService.updateNavigationItem(module.navigationName, {
                    hidden: true
                });
            }
        });

        for (const group of this._fuseNavigationService.getNavigation('main')) {

            this.ajustaChildrens(group);
        }
    }

    resetModules() {
        this.systemModules.forEach((module) => {
            module.permiteEscrita = false;
            module.permiteLeitura = false;
        });
    }
}

export interface ModulePai {
    id: string;
    title: string,
    icon: string,
    menuPai: string,
}
